import i18next from 'i18next';
import { envConfig, getCurrentEnv } from '../config/envConfig';
import { tokenManager } from '../utils/tokenManager';
import { getCoreQueryParams } from '../utils/queryUtils';

export const translationService = {
  async fetchTranslations(languageCode = 'en') {
    try {
      const { productId, environmentId, countryId } = getCoreQueryParams();
      const token = tokenManager.getToken();

      const headers = {
        'Content-Type': 'application/json',
        'Cache-Control': 'max-age=86400, must-revalidate',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      };

      const currentEnv = getCurrentEnv();
      const base = envConfig[currentEnv]?.I18N_URL || '';
      const baseUrl = new URL(base);
      baseUrl.searchParams.set('languagecode', languageCode);
      if (productId) baseUrl.searchParams.set('productId', productId);
      if (environmentId) baseUrl.searchParams.set('environmentId', environmentId);
      if (countryId) baseUrl.searchParams.set('countryId', countryId);

      const response = await fetch(baseUrl.toString(), {
        method: 'GET',
        headers,
      });
      if (!response.ok) throw new Error(`Failed to fetch translations: ${response.status}`);

      const translations = await response.json();

      // API returns a flat dictionary of key -> value. Put it under the
      // default 'translation' namespace so useTranslation() can resolve keys.
      i18next.addResourceBundle(
        languageCode,
        'translation',
        translations,
        true,
        true
      );

      return translations;
    } catch (error) {
      console.error('Error fetching translations:', error);
      throw error;
    }
  },

  async initializeTranslations() {
    try {
      const userLanguage = navigator.language;
      const countryId = new URLSearchParams(window.location.search).get('countryId');

      // Explicit mapping of countryId to language codes
      const countryLangMap = {
        '1': 'sv',
        '9': 'en',
      };

      const browserLang = (userLanguage || '').substring(0, 2).toLowerCase();
      const supportedBrowserLang = ['sv', 'da', 'fi', 'no', 'de', 'en'].includes(browserLang)
        ? browserLang
        : 'en';

      const activeLang = countryLangMap[countryId] || supportedBrowserLang;

      await this.fetchTranslations(activeLang);
      await i18next.changeLanguage(activeLang);
      return activeLang;
    } catch (error) {
      console.error('Failed to initialize translations:', error);
      return 'en';
    }
  },
};


